import { FunctionalComponent, h } from '@stencil/core';

export interface PublicationSearchResultProps {
  path?: string;
  departmentName?: string;
  title?: string;
  subTitle?: string;
  description?: string;
  date?: string;
  tags?: string[];
  locked?: boolean;
}

export type PublicationSearchResultTemplateName = 'PublicationSearchResult';

export const PublicationSearchResult: FunctionalComponent<PublicationSearchResultProps> = ({
  path,
  title,
  departmentName,
  subTitle,
  date,
  description,
  tags,
  locked,
}) => {
  const tagList = tags ? JSON.stringify(tags.map((text) => ({ text }))) : null;

  const descriptionHtml = date
    ? `<span class="adl-publication-search-result__date">${date}.</span>&nbsp;&nbsp;` + (description || '')
    : description;

  const departmentNameTag = departmentName ? (
    <span class="adl-publication-search-result__department">{` [${departmentName}]`}</span>
  ) : null;

  const lockedIcon = locked
    ? [' ', <span class="adl-space__sm__m-l-xs adl-journal-article-icon adl-journal-article-icon--Key">Key</span>]
    : null;

  return (
    <article class="adl-publication-search-result">
      {(title || departmentNameTag) && (
        <h3 class="adl-publication-search-result__title">
          {path ? [<a href={path}>{title}</a>, departmentNameTag, lockedIcon] : [title, departmentNameTag, lockedIcon]}
        </h3>
      )}
      {subTitle && <p class="adl-publication-search-result__subtitle">{subTitle}</p>}
      {descriptionHtml && <div class="adl-publication-search-result__description" innerHTML={descriptionHtml} />}
      {tagList && <aafp-journal-article-tag-list tags={tagList} />}
    </article>
  );
};
